<template>
  <div class="approved_box pack_box">
    <ax-result-page v-if="showResult" type="network" subtext="要不然下拉刷新试试？"></ax-result-page>
    <div v-if="!showResult ">
      <div class="number">单号：343434</div>
      <ax-head v-if="!$route.query.apply">
        <div slot="ing">
          <p>
            来自{{ data.header.dept_descr || data.header.deptid_description }}的
            <em>{{ data.header.emplid_description }}</em>的
            <em>{{ pageObj.title }}{{data.header.qh_total_days ? data.header.qh_total_days + '天': ''}}申请单</em>，请您审批。
          </p>
        </div>
      </ax-head>
      <div
        v-if="data.header.wf_status"
        class="approve-result"
        :class="[{'pullout':isPullout},approvalStatus[data.header.wf_status]]"
      ></div>
      <upcoming-component v-if="pageId && data" :data="data" :options="pageObj.options || {}"></upcoming-component>
      <div>
        <ax-panel title="撤销原因" noBorder>
          <textarea class="comments_box" rows="5" v-model="data.comments" placeholder="请输入您的撤销原因"></textarea>
        </ax-panel>
        <div class="handle_box">
          <a class="reject" href="javascript:;" @click="handleCancel">撤销</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import absence from '@/backup/ehr/card.vue'
export default {
  components: {
    'upcomingComponent': absence
  },
  data(){
    return {
      data: {
        header: {
          dept_descr: "信息化部",
          emplid_description: '孔维民',
          title: '休假申请',
          qh_total_days: 1,
          wf_status: 'A'
        }
      },
      isPullout: true,
      pageId: 'absence',
      showResult: false,
      pageObj: {}
    }
    
  },
  methods: {
    handleCancel(){

    }
  }
}
</script>

<style>
</style>